import {
  FIRE_EMERGENCY_CHIEF_FIRE_OFFICER,
  FIRE_EMERGENCY_SR_MANAGER,
} from "common/constant";
import { isAuthorizedUser } from "./isAuthorizedUser";

export const getAllowedStatusForFireSafetyApplications = (
  applicationStatus,
  userRoles
) => {
  const { approvedBy, rejectedBy, revokedBy } = applicationStatus;

  if (
    isAuthorizedUser(userRoles, [FIRE_EMERGENCY_CHIEF_FIRE_OFFICER]) &&
    [FIRE_EMERGENCY_SR_MANAGER].includes(approvedBy)
  ) {
    return {
      canApproved: true,
      canRejected: true,
      canRevoked: true,
    };
  }

  if (isAuthorizedUser(userRoles, [FIRE_EMERGENCY_SR_MANAGER])) {
    return {
      canApproved: !approvedBy && !rejectedBy,
      canRejected: false,
      canRevoked: [FIRE_EMERGENCY_CHIEF_FIRE_OFFICER].includes(revokedBy),
    };
  }

  return {
    canApproved: false,
    canRevoked: false,
    canRejected: false,
  };
};
